import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
@Component({
  selector: 'app-add-referral',
  templateUrl: './add-referral.component.html',
  styleUrls: ['./add-referral.component.scss'],
})
export class AddReferralComponent {

  constructor( public service: ApiService,
    public router: Router, public handler: HandlerService) { }
  numCd = ["+91"];
  data: any = [];
  items: any = [{ referralName: "", referralContactNbr: "", icon: 'add', referralEmail: "", numCd: "+91" }];
  msg;
  loader: boolean = false;
  orgs: any;
  orgrefer: boolean;
  maxlength ='10';



  async ionViewWillEnter() {
    let url = window.location.href;
    if (url.includes('addOrgreferral')) {
      this.orgrefer = true;
      await this.service.getOrgByCode('YB').subscribe(res => {
        this.orgs = res;
      },
        err => {
          this.handler.err(err)
        });
    }
    else {
      this.orgrefer = false;
    }
  }

  add() {
    var len1 = this.items.length;

    if (this.items[len1 - 1].referralContactNbr != "") {
      this.items.push({ referralName: "", referralContactNbr: "", icon: 'add', referralEmail: "", numCd: "+91" });
      this.numCd.push("+91");
    }
    else {
      this.handler.res("Please Enter Required fields");
    }

  }
  addmore(data, i) {
    if (data.icon === "clear") {
      this.items.splice(i, 1);
    }
    else {
      this.items[i].icon = "clear";
      this.items.push({ referralName: "", referralContactNbr: "", icon: 'add', referralEmail: "", numCd: "+91" });
    }
  }
  save() {
    this.loader = true
    let ref: any = [];
    this.items.map((res, i) => {
      ref.push({
        referralName: res.referralName,
        referralContactNbr: this.numCd[i] + res.referralContactNbr,
        referralEmail: res.referralEmail
      })
    })
    var post;
    let url = window.location.href;
    if (url.includes('addOrgreferral')) {
      post = {
        type: 2,
        referredOrgId: this.orgs.id,
        referrerUserId: localStorage.getItem('currentUserId'),
        message: this.msg,
        referrals: ref,
      }
    }
    else {
      post = {
        type: 1,
        referredOrgId: localStorage.getItem('organizationId'),
        referrerUserId: localStorage.getItem('currentUserId'),
        message: this.msg,
        referrals: ref

      }
    }

    this.service.postReferrals(post).subscribe(res => {
      this.loader = false;
      this.handler.res("Referral Added Successfully");
      this.router.navigate(['/refer-dash']);
    }, err => {
      this.handler.err(err);
      this.loader = false;
    })

  }
  save1(){
    let x=this.items.every(res=>res.referralContactNbr&&res.referralName);
      if(!x){
        this.handler.res("Please Enter Mobile Number,Name");
      }
      else{
        this.save();
      }
  }

}
